interface OrganisationData {
    '@id': string;
    'uri': string;
    'id': number;
    'name': string;
    'owner': string;
}

export class User {
    uri: string;
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    organisations: string[];
    forms: string[];
    isMe: boolean;
    isOwner = false;
    plainPassword: string | null = null;

    constructor(data: any) {
        this.uri = data['@id'];
        this.id = data.id;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.email = data.email;
        this.phoneNumber = data.phoneNumber;
        this.forms = data.forms;
        this.organisations = data.organisations;
        this.isMe = data.isMe;
    }
}
export class Organisation {
    uri: string;
    id: number;
    name: string;
    ownerUri: string;

    constructor(data: OrganisationData) {
        this.uri = data['@id'];
        this.id = data.id;
        this.name = data.name;
        this.ownerUri = data.owner;
    }
}
